<template>
  <div>
    <div class="my-canvas">
      <canvas ref="canvas" width="width"></canvas>
    </div>
  </div>
</template>

<style lang="less" scoped>
.my-canvas {
  border: 1px solid #f1f1f1;

  canvas {
    width: 100%;
    display: block;
  }
}
</style>

<script>
import json2canvas from "./json2canvas/index";

export default {
  props: {
    params: {
      type: Object,
    },
  },
  computed: {
    canvasOptions() {
      return {
        ratio: 4,
        config: {
          type: "div",
          css: {
            padding: [20, 20, 20, 20],
            backgroundColor: "#FFF",
            width: 500,
          },
          children: [
            {
              type: "div",
              css: {
                padding: [8, 8, 8, 8],
                opacity: 0.7,
                textAlign: "center",
              },
              children: [
                {
                  type: "text",
                  hidden: !this.params.doctorInfo || !this.params.doctorInfo.vetCompany,
                  text: `${
                    this.params.doctorInfo && this.params.doctorInfo.vetCompany
                  } 处方笺`,
                  css: {
                    lineHeight: 14,
                    display: "inline-block",
                    color: "#333",
                    fontSize: 14,
                  },
                },
              ],
            },
            {
              type: "text",
              text: `No.${this.params.guid}`,
              css: {
                color: "#ff0000",
                fontSize: 10,
                lineHeight: 20,
                top: 5,
                width: 500,
                textAlign: "right",
                display: "inline-block",
              },
            },
            {
              type: "div",
              css: {
                opacity: 0.7,
              },
              children: [
                {
                  type: "text",
                  text:
                    "动物主人/饲养单位：____________________________________________病例号：____________________",
                  css: {
                    width: 500,
                    color: "#1f1f1f",
                    fontSize: 10,
                    lineHeight: 20,
                    textAlign: "left",
                    display: "inline-block",
                  },
                },
              ],
            },
            {
              type: "div",
              css: {
                backgroundColor: "#FFF",
                position: "float",
              },
              children: [
                {
                  type: "text",
                  text: `${
                    [this.params.consumeName, this.params.consumePhone]
                      .filter((item) => !!item)
                      .join(", ") || "空"
                  }`,
                  css: {
                    top: -21,
                    left: 100,
                    width: 330,
                    color: "#919191",
                    fontSize: 10,
                    lineHeight: 20,
                    textAlign: "left",
                    display: "inline-block",
                  },
                },
              ],
            },
            {
              type: "div",
              css: {
                backgroundColor: "#FFF",
                opacity: 0.7,
              },
              children: [
                {
                  type: "text",
                  text:
                    "动物种类：____________________ 动物性别：____________________ 动物毛色：____________________",
                  css: {
                    width: 500,
                    color: "#1f1f1f",
                    fontSize: 10,
                    lineHeight: 20,
                    textAlign: "left",
                    display: "inline-block",
                  },
                },
              ],
            },
            {
              type: "div",
              css: {
                backgroundColor: "#FFF",
                position: "float",
              },
              children: [
                {
                  type: "text",
                  text: `${this.params.petType || "未知"}`,
                  css: {
                    top: -21,
                    left: 60,
                    width: 160,
                    color: "#919191",
                    fontSize: 10,
                    lineHeight: 20,
                    textAlign: "left",
                    display: "inline-block",
                  },
                },
                {
                  type: "text",
                  text: `${this.params.petGender || "未知"}`,
                  css: {
                    top: -21,
                    left: 60,
                    width: 160,
                    color: "#919191",
                    fontSize: 10,
                    lineHeight: 20,
                    textAlign: "left",
                    display: "inline-block",
                  },
                },
              ],
            },
            {
              type: "div",
              css: {
                backgroundColor: "#FFF",
                opacity: 0.7,
              },
              children: [
                {
                  type: "text",
                  text:
                    "体重：______________________年（日）龄：____________________ 开具日期：____________________ ",
                  css: {
                    width: 500,
                    color: "#1f1f1f",
                    fontSize: 10,
                    lineHeight: 20,
                    textAlign: "left",
                    display: "inline-block",
                  },
                },
              ],
            },
            {
              type: "div",
              css: {
                backgroundColor: "#FFF",
                position: "float",
              },
              children: [
                {
                  type: "text",
                  text: `${this.params.petWeight || "未知"}`,
                  css: {
                    top: -21,
                    left: 70,
                    width: 160,
                    color: "#919191",
                    fontSize: 10,
                    lineHeight: 20,
                    textAlign: "left",
                    display: "inline-block",
                  },
                },
                {
                  type: "text",
                  text: `${this.params.petAge || "未知"}`,
                  css: {
                    top: -21,
                    left: 60,
                    width: 160,
                    color: "#919191",
                    fontSize: 10,
                    lineHeight: 20,
                    textAlign: "left",
                    display: "inline-block",
                  },
                },
                {
                  type: "text",
                  text: `${new Date(this.params.createTime).format("YYYY-MM-dd")}`,
                  css: {
                    top: -21,
                    left: 60,
                    width: 160,
                    color: "#919191",
                    fontSize: 10,
                    lineHeight: 20,
                    textAlign: "left",
                    display: "inline-block",
                  },
                },
              ],
            },
            {
              type: "div",
              css: {
                width: 500,
                height: 10,
              },
              children: [],
            },
            {
              type: "div",
              css: {
                backgroundColor: "#f1f1f1",
                width: 500,
                height: 1,
              },
              children: [],
            },
            {
              type: "div",
              css: {
                width: 500,
                height: 10,
              },
              children: [],
            },
            {
              type: "div",
              css: {
                backgroundColor: "#FFF",
              },
              children: [
                {
                  type: "text",
                  text: "诊断：",
                  css: {
                    color: "#1f1f1f",
                    fontSize: 10,
                    lineHeight: 20,
                    textAlign: "right",
                    display: "inline-block",
                  },
                },
                {
                  type: "text",
                  text: "Rp：",
                  css: {
                    color: "#1f1f1f",
                    left: 120,
                    fontSize: 10,
                    lineHeight: 20,
                    textAlign: "right",
                    display: "inline-block",
                  },
                },
              ],
            },
            {
              type: "div",
              css: {
                backgroundColor: "#FFF",
              },
              children: [
                {
                  type: "wrapText",
                  text: `${
                    this.params.diseaseList ? `疑似${this.params.diseaseList}` : "空"
                  }`,
                  css: {
                    left: 30,
                    width: 160, // 到宽度边界时换行
                    color: "#919191",
                    fontSize: 8,
                    lineHeight: 12,
                    display: "inline-block",
                  },
                },
                {
                  type: "wrapText",
                  text: `${this.params.rpList ? this.params.rpList : "空"}`,
                  css: {
                    left: 20,
                    width: 280,
                    color: "#919191",
                    fontSize: 8,
                    lineHeight: 12,
                    display: "inline-block",
                  },
                },
              ],
            },
            {
              type: "div",
              css: {
                width: 500,
                height: 10,
              },
              children: [],
            },
            {
              type: "div",
              css: {
                backgroundColor: "#f1f1f1",
                width: 500,
                height: 1,
              },
              children: [],
            },
            {
              type: "div",
              css: {
                width: 500,
                height: 10,
              },
              children: [],
            },
            {
              type: "div",
              hidden: !this.params.doctorInfo,
              css: {
                backgroundColor: "#FFF",
              },
              children: [
                {
                  type: "text",
                  text: "执业兽医师:",
                  css: {
                    color: "#1f1f1f",
                    width: 60,
                    fontSize: 10,
                    lineHeight: 20,
                    display: "inline-block",
                  },
                },
                {
                  type: "image",
                  hidden: !this.params.doctorInfo || !this.params.doctorInfo.signature,
                  url: `${
                    (this.params.doctorInfo && this.params.doctorInfo.signature) || ""
                  }`,
                  css: {
                    top: -5,
                    width: 80,
                    height: 30,
                    display: "inline-block",
                  },
                },
                {
                  type: "text",
                  hidden:
                    !this.params.doctorInfo || !this.params.doctorInfo.vetCertificateId,
                  text: `注册号: ${
                    (this.params.doctorInfo && this.params.doctorInfo.vetCertificateId) ||
                    ""
                  }`,
                  css: {
                    color: "#1f1f1f",
                    left: 50,
                    width: 200,
                    fontSize: 10,
                    lineHeight: 20,
                    display: "inline-block",
                  },
                },
                {
                  type: "text",
                  hidden:
                    !this.params.doctorInfo || !this.params.doctorInfo.vetCertificateId,
                  text: `发药人: ${this.params.handledBy || ""}`,
                  css: {
                    color: "#1f1f1f",
                    left: 50,
                    width: 200,
                    fontSize: 10,
                    lineHeight: 20,
                    display: "inline-block",
                  },
                },
              ],
            },
            {
              type: "div",
              hidden: !this.params.doctorInfo,
              css: {
                backgroundColor: "#FFF",
              },
              children: [
                {
                  type: "wrapText",
                  text: `提示：\n1.请遵医嘱用药\n2.处方开具当日有效\n3.发出药品不予退还`,
                  css: {
                    color: "#919191",
                    width: 200,
                    fontSize: 8,
                    lineHeight: 12,
                    display: "inline-block",
                  },
                },
              ],
            },
          ],
        },
      };
    },
  },
  watch: {
    params() {
      this.draw();
    },
  },
  methods: {
    draw() {
      if (!this.params) {
        return;
      }
      json2canvas(this.canvasOptions).then((image) => {
        let can = this.$refs.canvas;
        let context = can.getContext("2d");
        can.width = image.width;
        can.height = image.height;
        context.drawImage(image, 0, 0);
      });
    },
  },
  mounted() {
    this.draw();
  },
};
</script>
